module.exports = __webpack_public_path__ + "img/I5.479f5304.png";